import moment from 'moment'
import {
  operatorByValue,
  usersKey,
  tagKey,
  uidKey,
  dateKey,
  environmentKey,
  assetTypeKey,
  fileSizeKey,
  fileNameKey,
  urlKey,
  titleKey,
  commonQueryFormat,
  advSearchTextLabelKey
} from '../constant'

import { getFileSizeLabel } from '../helper'

export const assetQueryFormat = {
  filename: {
    key: [{ label: 'File Name', value: 'filename' }],
    operator: [],
    value: [],
    queryType: 'fileNameLabel'
  },
  url: {
    key: [{ label: 'URL', value: 'url' }],
    operator: [],
    value: [],
    queryType: 'urlLabel'
  },
  title: {
    key: [{ label: 'Title', value: 'title' }],
    operator: [],
    value: [],
    queryType: 'titleLabel'
  },
  file_size: {
    key: [{ label: 'File Size', value: 'file_size' }],
    operator: [],
    value: [],
    queryType: 'fileSizeLabel'
  },
  _content_type_uid: {
    key: [{ label: 'Type', value: '_content_type_uid' }],
    operator: [],
    value: [],
    queryType: 'typeLabel'
  },
  tags: {
    key: [{ label: 'Tags', value: 'tags' }],
    operator: [],
    value: [],
    queryType: 'assetTagLabel'
  },
  ...commonQueryFormat
}

const parseQueryForObject = ({ queryKey, query, users, types, queryArray }) => {
  const value = Object.values(query[queryKey])[0]
  const operator = Object.keys(query[queryKey])[0]
  const sampleQuery = assetQueryFormat[queryKey]

  if (usersKey.includes(queryKey)) {
    const foundUser = users.find((user) => user.value === value)
    const rawQuery = {
      ...sampleQuery,
      operator: [operatorByValue[operator]],
      value: [{ label: foundUser ? foundUser.label : value, value }]
    }
    queryArray.push(rawQuery)
    return
  }

  if (advSearchTextLabelKey === queryKey) {
    const value = Object.values(query[queryKey])[0]
    const operator = Object.keys(query[queryKey])[0]
    const sampleQuery = commonQueryFormat[queryKey]
    const rawQuery = {
      ...sampleQuery,
      operator: [operatorByValue[operator]],
      value: [{ label: value, value }]
    }
    queryArray.push(rawQuery)
  }

  if (assetTypeKey === queryKey) {
    const foundAssetType = types.find((assetType) => assetType.value === value)
    const rawQuery = {
      ...sampleQuery,
      operator: [operatorByValue[operator]],
      value: [{ label: foundAssetType ? foundAssetType.label : value, value }]
    }
    queryArray.push(rawQuery)
  }

  if (uidKey === queryKey) {
    // const operator = Object.keys(query[queryKey])[0]
    // const sampleQuery = entriesQueryFormat[queryKey]
    const rawQuery = {
      ...sampleQuery,
      operator: [operatorByValue[operator]],
      value: [{ label: value, value, type: 'text' }]
    }
    queryArray.push(rawQuery)
  }

  if (dateKey.includes(queryKey)) {
    const localDate = moment(value).format('YYYY-MM-DD')
    const controlledOp = operator === '$eq' ? { label: 'Equals', value: '$eq' } : operatorByValue[operator]
    const rawQuery = {
      ...sampleQuery,
      operator: [controlledOp],
      value: [{ label: localDate, value: localDate }]
    }
    queryArray.push(rawQuery)
    return
  }

  if (fileSizeKey === queryKey) {
    const rawQuery = {
      ...sampleQuery,
      operator: [operatorByValue[operator]],
      value: [{ label: getFileSizeLabel(value), value }]
    }
    queryArray.push(rawQuery)
    return
  }

  if (commonQueryFormat === queryKey) {
    const value = Object.values(query[queryKey])[0]
    const operator = Object.keys(query[queryKey])[0]
    const sampleQuery = commonQueryFormat[queryKey]
    const rawQuery = {
      ...sampleQuery,
      operator: [operatorByValue[operator]],
      value: [{ label: value, value }]
    }
    queryArray.push(rawQuery)
  }

  if (environmentKey === queryKey) {
    const [value]: any = Object.values(query[queryKey])[0]
    const rawQuery = {
      ...sampleQuery,
      operator: [operatorByValue[operator]],
      value: [{ label: value, value }]
    }
    queryArray.push(rawQuery)
    return
  }

  if ([fileNameKey, urlKey, titleKey, tagKey].includes(queryKey)) {
    let evalOp = operatorByValue[operator]
    let evalValue = { label: value, value: value }

    // DONT REMOVE THIS, this is commented for SEPT 11 release
    // null not null check
    if (operator === '$exists') {
      let valueForNullNotNull = Object.values(query[queryKey])[0]
      evalOp = { ...evalOp, label: valueForNullNotNull ? 'Is not empty' : 'Is empty' }
      evalValue = { value: valueForNullNotNull, label: '' }
    }

    const rawQuery = {
      ...sampleQuery,
      operator: [evalOp],
      value: [evalValue]
    }
    queryArray.push(rawQuery)
    return
  }
}

export const queryParserAssets = async (queryObject, search_text, fetchData, cacheResponse?) => {
  try {
    let queryArray = []

    // if (search_text) {
    //   queryArray.push({
    //     ...assetsFormat,
    //     value: [{ label: search_text, value: search_text, type: 'text' }]
    //   })
    // }

    const { $and: andArray = [] } = queryObject || {}

    if (!queryObject || !Array.isArray(andArray)) {
      return queryArray
    }

    let userResponse = cacheResponse.userResponse || []
    let typesResponse = cacheResponse.typesResponse || []

    // userResponse =
    // typesResponse =

    // if (cacheResponse) {
    // } else {
    //   const response = await fetchDataForQuery(andArray, fetchData)
    //   userResponse = response.userResponse
    //   typesResponse = response.typesResponse
    // }

    andArray.forEach((query) => {
      const queryKey = Object.keys(query)[0]
      parseQueryForObject({
        queryKey,
        query,
        users: userResponse,
        types: typesResponse,
        queryArray
      })
    })

    return queryArray
  } catch (error) {
    console.log('queryParserAssets', error)
    throw error
  }
}

export const advanceQueryAssetParser = async (query, selectedModule, fetchData, cache: any = {}, isRoot = true) => {
  const isQuery = (q) => Object.keys(q).includes('$and') || Object.keys(q).includes('$or')
  const firstKey = Object.keys(query)[0]

  const subQueries = []
  const currentQueryFields = []
  const children = []

  if (isQuery(query)) {
    const curQuery = query[firstKey]
    for (let subQuery of curQuery) {
      if (isQuery(subQuery)) {
        subQueries.push(subQuery)
      } else {
        currentQueryFields.push(subQuery)
      }
    }
  }

  const currentQuery = { $and: currentQueryFields }
  let queryArray = await queryParserAssets(currentQuery, '', fetchData, cache)

  for (let subQuery of subQueries) {
    const queryObject = await advanceQueryAssetParser(subQuery, selectedModule, fetchData, cache, false)

    if (queryObject) {
      children.push(queryObject)
    }
  }

  const data: any = {}

  if (isRoot) data.root = true

  data.children = children
  data.queryArray = queryArray
  data.queryType = firstKey === '$and' ? 'matchAll' : 'matchAny'

  return data
}
